import moment from 'moment';
export default function toLocalMoment(date) {
  return moment(moment.utc(date).toDate()).local();
}